import React, {useCallback, useEffect, useState} from 'react';
import {ApiService, filter} from "../../../../service/ApiService";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {Pagination} from "../../../../components/admin/Pagination";
import {Tab} from "../../../../components/admin/route/Tab";
import {stepCompletionResultType} from "../../../../types/Api/StepResultType";
import {StepList} from "../../../../components/admin/route/StepList";

type sort = {
  by: keyof stepCompletionResultType,
  direction?: 'ASC' | 'DESC'
}

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState([] as filter[]);
  const [sort, setSort] = useState({by: 'label', direction: 'ASC'} as sort);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);
  const [steps, setSteps] = useState([] as stepCompletionResultType[]);
  const [stepDiplays, setStepDiplays] = useState([] as stepCompletionResultType[]);

  const findStep = useCallback((): void => {
    setLoading(true);

    const result = ApiService.get(`/step/completion`) as Promise<stepCompletionResultType[]>;

    result
      .then((r: stepCompletionResultType[]) => {
        setInitialized(true);
        setSteps(r);
        setPagination({
          page: 1,
          pageCount: Math.ceil(r.length/count),
          total: r.length,
          count: count,
        });
      })
      .catch((e) => {
        alert("Une erreur c'est produite.")
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count]);

  useEffect(() => {
    setPage(1);
  }, [filter]);

  useEffect(() => {
    let stepsFiltered = steps;

    filter.forEach((f) => {
      const lowerKeyword = f.value.replaceAll('*', '').toLowerCase();

      stepsFiltered = stepsFiltered.filter(step =>
        step.label.toLowerCase().includes(lowerKeyword)
      );
    });

    stepsFiltered = stepsFiltered.slice().sort((a: stepCompletionResultType, b: stepCompletionResultType) => {
      if (a[sort.by] < b[sort.by]) {
        return sort.direction === 'ASC' ? -1 : 1;
      }

      if (a[sort.by] > b[sort.by]) {
        return sort.direction === 'ASC' ? 1 : -1;
      }

      return 0;
    });

    const start = (page - 1) * count;
    const end = start + count;

    setStepDiplays(stepsFiltered.slice(start, end));

    setPagination({
      page: page,
      pageCount: Math.ceil(stepsFiltered.length/count),
      total: stepsFiltered.length,
      count: count,
    });
  }, [count, page, filter, sort, steps]);

  useEffect(() => {
    findStep();
  }, [findStep]);

  return (
    <>
      <BoxTitle title="Gestion des parcours"/>
      <Tab/>
      <StepList steps={stepDiplays} loading={loading} refresh={findStep} sort={sort}
                   filter={(filter: filter[]) => {
                     setFilter(filter)
                   }}
                   order={(s: string) => {
                     setSort({
                       by: s as keyof stepCompletionResultType,
                       direction: (s !== sort?.by || sort.direction === 'DESC') ? 'ASC' : 'DESC'
                     })
                   }}
      />
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
    </>
  )
}
